/**
 * TEMPORARY hardcoded config — replace with API-driven field from
 * receipt_view_service_settings once the backend delivers the schema change.
 */

export interface EmailExportConfig {
  method: "email_pdf";
  domainWhitelist: string[] | null;
}

/** Keyed by receipt_view_service_settings_id */
export const EMAIL_EXPORT_WIDGETS: Record<string, EmailExportConfig> = {
  "019da3d7-0b32-8031-8f31-405c79cbf850": {
    method: "email_pdf",
    domainWhitelist: ["bilag.fiken.no"],
  },
};

export const getEmailExportConfig = (
  settingsId: string
): EmailExportConfig | null => {
  return EMAIL_EXPORT_WIDGETS[settingsId] ?? null;
};

export const hasEmailExportFor = (
  userId: string | undefined,
  receiptId: string | undefined,
  settingsId: string
): boolean => !!userId && !!receiptId && !!getEmailExportConfig(settingsId);
